export default ({ login }, _, { t }) => {
  if (login) {
    return `${t('log_in_to_flipboard')}`;
  }
};
